import React, { useEffect, useState } from "react";
import { Users, GraduationCap, Handshake, TrendingUp } from "lucide-react";
import { AnimatedCounter } from "./AnimatedCounter";
import api from "../lib/api";

const icons = [Users, GraduationCap, Handshake, TrendingUp];

export default function StatsSection() {
  const [stats, setStats] = useState({
    students_trained: 5000,
    courses_offered: 25,
    industry_partners: 60,
    placement_rate: 95,
  });

  useEffect(() => {
    api.get("/stats").then((r) => setStats(r.data)).catch(() => {});
  }, []);

  const items = [
    { value: stats.students_trained, suffix: "+", label: "Students Trained" },
    { value: stats.courses_offered, suffix: "+", label: "Courses Offered" },
    { value: stats.industry_partners, suffix: "+", label: "Industry Partners" },
    { value: stats.placement_rate, suffix: "%", label: "Placement Rate" },
  ];

  return (
    <section className="py-16 bg-[#0B2A6B] relative overflow-hidden">
      <div
        className="absolute inset-0 opacity-[0.07]"
        style={{
          backgroundImage:
            "linear-gradient(to right, #fff 1px, transparent 1px), linear-gradient(to bottom, #fff 1px, transparent 1px)",
          backgroundSize: "40px 40px",
        }}
      />
      <div className="absolute -top-16 right-1/4 w-64 h-64 bg-yellow-400/10 rounded-full blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {items.map((it, i) => {
            const Icon = icons[i];
            return (
              <div key={it.label} className="text-center group">
                <div className="inline-flex items-center justify-center h-14 w-14 rounded-2xl bg-yellow-400/15 group-hover:bg-yellow-400 transition mb-4">
                  <Icon className="h-7 w-7 text-yellow-400 group-hover:text-[#0B2A6B] transition" />
                </div>
                <div className="text-4xl sm:text-5xl font-bold text-yellow-400">
                  <AnimatedCounter value={it.value} suffix={it.suffix} />
                </div>
                <div className="mt-2 text-sm font-medium text-slate-200">{it.label}</div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
